export default __webpack_public_path__ + "static/media/touchTwo.094157bd.svg";